var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82,11.76v1H6a2.73,2.73,0,0,1,.38-1.09,7.29,7.29,0,0,1,1.23-1.38,7.56,7.56,0,0,0,.91-.93,1.16,1.16,0,0,0,.23-.68.77.77,0,0,0-.2-.56.83.83,0,0,0-1.09,0,1.1,1.1,0,0,0-.23.69L6.1,8.73a1.77,1.77,0,0,1,.62-1.3A2,2,0,0,1,8,7a1.88,1.88,0,0,1,1.33.46,1.5,1.5,0,0,1,.48,1.14,1.83,1.83,0,0,1-.14.73,2.93,2.93,0,0,1-.44.74,8.55,8.55,0,0,1-.71.73,7.4,7.4,0,0,0-.66.63,1.5,1.5,0,0,0-.23.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid02);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_02.facdef4f9b9a596301571ac433691a0e.svg";
export { ForwardRef as ReactComponent };